import { db } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Função para buscar todos os atendimentos do usuário logado
export async function fetchAtendimentos() {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) {
    throw new Error('Usuário não autenticado');
  }

  const snapshot = await getDocs(
    query(collection(db, 'atendimentos'), where('userId', '==', userId))
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

// Função para buscar todas as clínicas do usuário logado
export async function fetchClinicas() {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) {
    throw new Error('Usuário não autenticado');
  }

  const snapshot = await getDocs(
    query(collection(db, 'clinicas'), where('userId', '==', userId))
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

// Função para buscar todos os pacientes do usuário logado
export async function fetchPacientes() {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) {
    throw new Error('Usuário não autenticado');
  }

  const snapshot = await getDocs(
    query(collection(db, 'pacientes'), where('userId', '==', userId))
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

// Função para buscar atendimentos com filtros e do usuário logado
export async function fetchFilteredAtendimentos(
  clinicaId,
  dataInicio,
  dataFim,
  pacienteId
) {
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  if (!userId) {
    throw new Error('Usuário não autenticado');
  }

  let q = query(collection(db, 'atendimentos'), where('userId', '==', userId));

  if (clinicaId) {
    q = query(q, where('clinica', '==', clinicaId));
  }

  if (dataInicio && dataFim) {
    q = query(
      q,
      where('dataAtendimento', '>=', dataInicio),
      where('dataAtendimento', '<=', dataFim)
    );
  }

  if (pacienteId) {
    q = query(q, where('nomePaciente', '==', pacienteId));
  }

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}
